import type {
  TripPricingSummarySuccess,
  AnyFailure,
  TripPricingSummaryResponse,
  PassengersForFareRequest,
  ErrorCode,
} from "@b2bportal/air-booking-api";

import { ParentState } from "@checkout/types";
import { fetchTripPricing } from "@hopper-b2b/api";
import { getTripPriceParamsParent } from "../selectors";
import type { ChildPassengerInformationContext } from "../states/PassengerInformation/context";
import { getTripPriceParams } from "../states/PassengerInformation/selectors";
import type { FlightContext } from "../types";

export const fetchTripPricingService = (
  context: ChildPassengerInformationContext | FlightContext
) =>
  new Promise((resolve, reject) => {
    let params: PassengersForFareRequest;
    if ((context as FlightContext)[ParentState.passengerInformation]) {
      params = getTripPriceParamsParent({
        context: context as FlightContext,
      });
    } else {
      params = getTripPriceParams({
        context: context as ChildPassengerInformationContext,
      });
    }

    if (!params) {
      reject({
        errors: [
          { code: "INVALID_PARAMS", details: "Invalid parameters" },
        ] as ErrorCode[],
      } as AnyFailure);
      return;
    }

    fetchTripPricing(params)
      .then((response: TripPricingSummaryResponse) => {
        if ((response as AnyFailure).errors) {
          reject(response as AnyFailure);
        } else {
          resolve((response as TripPricingSummarySuccess).value);
        }
      })
      .catch((e) => {
        reject({
          errors: [
            { code: e.code ?? "UNKNOWN_ERROR", details: e.message },
          ] as ErrorCode[],
          Response: e.response,
        } as AnyFailure);
      });
  });
